export const nftcard =  {
      dataCard : [
        {
          status: "Not-Staked",
          name : "Project: Homecubes 2",
          stackdays : "Days Staked on this Quarter : 0/90",
          expiry : "Staking expiry date: 11/12/2023",
          img : require('../assets/images/nftimage.svg'),
          id:1,
          nftName : "Art One",
          nftImg : require('../assets/images/nftimage.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 912,
          ownerName : "Chan"
        },
        {
          status: "Staked",
          name : "Project: Homecubes 2",
          stackdays : "Days Staked on this Quarter : 0/90",
          expiry : "Staking expiry date: 11/12/2023",
          img : require('../assets/images/nftimage.svg'),
          id:2,
          nftName : "Art Two",
          nftImg : require('../assets/images/nftimageOne.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 712,
          ownerName : "Stephen"
        },
        {
          status: "Not-Staked",
          name : "Project: Homecubes 2",
          stackdays : "Days Staked on this Quarter : 0/90",
          expiry : "Staking expiry date: 11/12/2023",
          img : require('../assets/images/nftimage.svg'),
          id:3,
          nftName : "Art Three",
          nftImg : require('../assets/images/nftimageTwo.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 312,
          ownerName : "Berlin"
        },
        {
          status: "Not-Staked",
          name : "Project: Homecubes 2",
          stackdays : "Days Staked on this Quarter : 0/90",
          expiry : "Staking expiry date: 11/12/2023",
          img : require('../assets/images/nftimage.svg'),
          id:4,
          nftName : "Art Four",
          nftImg : require('../assets/images/nftimageOne.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 127,
          ownerName : "Jack"
        },
        {
          status: "Staked",
          name : "Project: Homecubes 2",
          stackdays : "Days Staked on this Quarter : 0/90",
          expiry : "Staking expiry date: 11/12/2023",
          img : require('../assets/images/nftimage.svg'),
          id:5,
          nftName : "Art Five",
          nftImg : require('../assets/images/nftimageTwo.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 123,
          ownerName : "Tokio"
        },
        {
          status: "Not-Staked",
          name : "Project: Homecubes 2",
          stackdays : "Days Staked on this Quarter : 0/90",
          expiry : "Staking expiry date: 11/12/2023",
          img : require('../assets/images/nftimage.svg'),
          id:6,
          nftName : "Art Six",
          nftImg : require('../assets/images/nftimage.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 11,
          ownerName : "Professor"
        },
        {
            status: "Staked",
            name : "Project: Homecubes 2",
            stackdays : "Days Staked on this Quarter : 0/90",
            expiry : "Staking expiry date: 11/12/2023",
            img : require('../assets/images/nftimage.svg'),
            id:7,
          nftName : "Art Seven",
          nftImg : require('../assets/images/nftimageTwo.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 12,
          ownerName : "Charlie"
          },
          {
            status: "Staked",
            name : "Project: Homecubes 2",
            stackdays : "Days Staked on this Quarter : 0/90",
            expiry : "Staking expiry date: 11/12/2023",
            img : require('../assets/images/nftimage.svg'),
            id:8,
          nftName : "Art Eight",
          nftImg : require('../assets/images/nftimageOne.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 21,
          ownerName : "Scooby"
          },
      ],
      nftCard : [
        {
          id:1,
          name : "Art One",
          nftImg : require('../assets/images/nftimage.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 912,
          ownerName : "Chan"
        },
        {
          id:2,
          name : "Art Two",
          nftImg : require('../assets/images/nftimageOne.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 712,
          ownerName : "Stephen"
        },
        {
          id:3,
          name : "Art Three",
          nftImg : require('../assets/images/nftimageTwo.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 312,
          ownerName : "Berlin"
        },
        {
          id:4,
          name : "Art Four",
          nftImg : require('../assets/images/nftimageOne.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 127,
          ownerName : "Jack"
        },
        {
          id:5,
          name : "Art Five",
          nftImg : require('../assets/images/nftimageTwo.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 123,
          ownerName : "Tokio"
        },
        {
          id:6,
          name : "Art Six",
          nftImg : require('../assets/images/nftimage.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 11,
          ownerName : "Professor"
        },
        {
          id:7,
          name : "Art Seven",
          nftImg : require('../assets/images/nftimageTwo.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 12,
          ownerName : "Charlie"
        },
        {
          id:8,
          name : "Art Eight",
          nftImg : require('../assets/images/nftimageOne.png'),
          coinImg : require('../assets/images/bnbcoin.svg'),
          coinName : "BNB",
          coinValue : 21,
          ownerName : "Scooby"
        },
      ],
      collectionCard : [
        {
          id:1,
          collectionImg : require('../assets/images/collections/shapeOne.jpg'),
          collectionName : "Cubic",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
        {
          id:2,
          collectionImg : require('../assets/images/collections/shapeEight.jpg'),
          collectionName : "Circle",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
        {
          id:3,
          collectionImg : require('../assets/images/collections/shapeSeven.jpg'),
          collectionName : "Cylinder",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
        {
          id:4,
          collectionImg : require('../assets/images/collections/shapeSix.jpg'),
          collectionName : "Cubic",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
        {
          id:5,
          collectionImg : require('../assets/images/collections/shapeFive.jpg'),
          collectionName : "Square",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
        {
          id:6,
          collectionImg : require('../assets/images/collections/shapeFour.jpg'),
          collectionName : "Slice",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
        {
          id: 7,
          collectionImg : require('../assets/images/collections/shapeThree.jpg'),
          collectionName : "Angle",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
        {
          id:8,
          collectionImg : require('../assets/images/collections/shapeTwo.jpg'),
          collectionName : "Roll",
          floorPrice : 1.20,
          coinName : "BNB",
          items:120,
          created: 50,
          creatorFee : 5.55,
          collectionHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
        },
      ],
      tableData : [
        {
          event : "List",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "Sale",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "Transfer",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "Offer",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "CollectionOffer",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "List",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "Sale",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "Transfer",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "Offer",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
        {
          event : "CollectionOffer",
          price : 0.049,
          coinName : "BNB",
          from : "Rarible_sales",
          to : "Maureth",
          date : "2 Weeks ago"

        },
      ],
      projectCard : [
        {
          id:1,
          name : "First Project",
          projectImg : require('../assets/images/collections/shapeEight.jpg'),
          floorPrice : 1.2,
          coinName : "BNB",
          projectHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
        },
        {
          id:2,
          name : "Second Project",
          projectImg : require('../assets/images/collections/shapeSeven.jpg'),
          floorPrice : 3.2,
          coinName : "BNB",
          projectHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
        },
        {
          id:3,
          name : "Third Project",
          projectImg : require('../assets/images/collections/shapeThree.jpg'),
          floorPrice : 2.2,
          coinName : "BNB",
          projectHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
        },
        {
          id:4,
          name : "Fourth Project",
          projectImg : require('../assets/images/collections/shapeFour.jpg'),
          floorPrice : 1.8,
          coinName : "BNB",
          projectHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
        },
        {
          id:5,
          name : "Fifth Project",
          projectImg : require('../assets/images/collections/shapeFive.jpg'),
          floorPrice : 3.5,
          coinName : "BNB",
          projectHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
        },
        {
          id:6,
          name : "Sixth Project",
          projectImg : require('../assets/images/collections/shapeSix.jpg'),
          floorPrice : 5.5,
          coinName : "BNB",
          projectHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
        },
      ],
      rewardsCard : [
        {
          title : "First Reward Disctributed",
          date : "28 - Oct -22",
          hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        },
        {
          title : "Staking is Open",
          date : "14 - Dec -22",
          hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        },
        {
          title : "Property Bought",
          date : "24 - Dec -22",
          hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        },
        {
          title : "NFT Minted",
          date : "18 - Nov -22",
          hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        },
        {
          title : "Collection Shown",
          date : "20 - Jun -22",
          hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        },
        {
          title : "Second Reward Disctributed",
          date : "17 - Jul -22",
          hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        },
        

      ],
      commitmentData : [
        {
          title : "Transperancy",
        hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"

        },
        {
          title : "Registered",
        hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"

        },
        {
          title : "Guaranteed Return",
        hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"

        },
        {
          title : "Rewards",
        hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"

        },
        {
          title : "Backup",
        hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"

        },
        {
          title : "No Manipulation",
        hint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"

        },
        
      ],
      faqData : [
        {
          question : "What is HomeCubes ?",
          answer : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        },
        {
          question : "How Does in work?",
          answer : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        },
        {
          question : "Can I sell my property share later ?",
          answer : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        },
        {
          question : "Is it actually aproperty in real world, or is it only available in metaverse ?",
          answer : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        },
        {
          question : "What do I need to buy a property in NFTs ?",
          answer : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi utaliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        },
        
      ],
      blogData : [
        {
          id:1,
          blogImage : require('../assets/images/blogs/blogOne.jpg'),
          blogName : "How to make secure passive income in crypto",
          blogHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
          blogDate : "12- Dec -23",
          blogPosts : "Recent Post",
          blogPostList : [
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
          ]
        },
        {
          id:2,
          blogImage : require('../assets/images/blogs/blogTwo.jpg'),
          blogName : "How NFTs make real estate investment easier than before",
          blogHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
          blogDate : "12- Dec -23",
          blogPosts : "Recent Comments",
          blogPostList : [
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
            {
              listHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
          ]
        },
        {
          id:3,
          blogImage : require('../assets/images/blogs/blogThree.jpg'),
          blogName : "How NFTs make real estate investment easier than before",
          blogHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
          blogDate : "12- Dec -23",
        },
        {
          id:4,
          blogImage : require('../assets/images/blogs/blogOne.jpg'),
          blogName : "How NFTs make real estate investment easier than before",
          blogHint : "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
          blogDate : "12- Dec -23",
        },

      ]

    }
  